import React, { useState, useEffect } from "react";
import { useNavigation } from "react-router-dom";
import { Mail, Smartphone, SquarePen, Trash2 } from "lucide-react";
import goal from "../../../assets/images/Coin-Wallet.png";
import Trophy from "../../../assets/images/Percentage.png";
import { userApi } from "../../../api/user";
import { useAuth } from "../../../context/AuthContext";
import toast from "react-hot-toast";

export default function GameCard({
  id,
  icon: Icon,
  name,
  reference,
  rates,
  win,
  commission,
  doubleWin,
  tripleWin,
  drawTimes,
  cutoffTimes,
  user_game_active,
  onToggleStatus,
  userId,
  selectedUserId
}) {
  const { tokens } = useAuth();
  const [isActive, setIsActive] = useState(user_game_active);

  const toggleHandler = async () => {
    const newActiveState = !isActive;
    try {
      const response = await userApi.updateUserGame(
        tokens.access.token,
        selectedUserId,
        id,
        newActiveState
      );

      console.log('response', response)

      if (response.status === 201) {
        setIsActive(newActiveState);
        toast.success(`Game ${newActiveState ? 'activated' : 'deactivated'}`);
        onToggleStatus(id, newActiveState);
      } else {
        toast.error("Failed to update game status");
      }
    } catch (error) {
      console.error("Error updating game status:", error);
      toast.error("Error updating game status");
      setIsActive(isActive);
    }
  };

  return (
    <>
      <div className="flex items-start gap-2.5 border p-2.5 mt-2.5 rounded-md">
        <Icon width={62} height={62} className="rounded-lg" />
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h3 className="font-bold text-base">{name}</h3>

            {/* toggle button start */}
            <div className="flex items-center justify-center ">
              <button
                onClick={toggleHandler}
                className={`flex items-center justify-between rounded-full px-1 w-20 h-6  ${
                  isActive
                    ? "bg-green-500"
                    : "bg-gray-300 transition-colors duration-300"
                }`}
              >
                {isActive ? (
                  <>
                    <span
                      className={`text-[10px] font-normal ps-2 text-white translate-x-0 transition-transform duration-300 `}
                    >
                      Active
                    </span>
                    <div
                      className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform `}
                    ></div>
                  </>
                ) : (
                  <>
                    <div
                      className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform `}
                    ></div>
                    <span
                      className={`text-[10px] font-normal pe-2 text-gray-800 translate-x-0`}
                    >
                      Inactive
                    </span>
                  </>
                )}
              </button>
            </div>
            {/* toggle button end */}
          </div>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-[#12131A] font-normal">
              Game Reference:{" "}
              <span className="text-[#0E64D1]"> {reference} </span>{" "}
            </span>
          </div>
          <div className="flex items-center gap-2 ">
            <span className="text-xs text-[#12131A]  font-normal">
              Game Rates:{" "}
              <span className="text-[#0E64D1]">
                {" "}
                ₱{rates.amount} | {rates.percentage}%{" "}
              </span>
            </span>
          </div>

          <div className="flex gap-6 mt-4">
            <div>
              <div className="text-[10px] text-[#65758B]">Win</div>
              <div className="font-semibold text-xs">₱{win}</div>
            </div>

            <div>
              <div className="text-[10px] text-[#65758B]">Commission</div>
              <div className="font-semibold text-xs">{commission}%</div>
            </div>

            <div>
              <div className="text-[10px] text-[#65758B]">Double Win</div>
              <div className="font-semibold text-xs">₱{doubleWin}</div>
            </div>

            <div>
              <div className="text-[10px] text-[#65758B]">Triple Win</div>
              <div className="font-semibold text-xs">₱{tripleWin}</div>
            </div>
          </div>

          <div className="flex gap-6 mt-4">
            <div className="flex items-center w-full">
              <div className="text-[10px] text-[#65758B] whitespace-nowrap">
                Draw Time
              </div>
              <div className="flex-1 h-[1px] bg-[#E1E7EF] ml-2"></div>
            </div>
          </div>

          <div className="flex">
            {drawTimes?.map((time, index) => (
              <div 
                key={index}
                className={`font-semibold text-xs ${
                  index !== 0 ? 'border-l border-[#E1E7EF] px-2' : 'pe-2'
                }`}
              >
                {time}
              </div>
            ))}
            {(!drawTimes || drawTimes.length === 0) && (
              <div className="text-xs text-gray-400">No draw times available</div>
            )}
          </div>

          <div className="flex gap-6 mt-4">
            <div className="flex items-center w-full">
              <div className="text-[10px] text-[#65758B] whitespace-nowrap">
                Cut off Time
              </div>
              <div className="flex-1 h-[1px] bg-[#E1E7EF] ml-2"></div>
            </div>
          </div>

          <div className="flex">
            {cutoffTimes?.map((time, index) => (
              <div 
                key={index}
                className={`font-semibold text-xs ${
                  index !== 0 ? 'border-l border-[#E1E7EF] px-2' : 'pe-2'
                }`}
              >
                {time}
              </div>
            ))}
            {(!cutoffTimes || cutoffTimes.length === 0) && (
              <div className="text-xs text-gray-400">No cutoff times available</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
